
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("lPUNq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3X3EV = parcelRequire("3X3EV");


var $jkMwL = parcelRequire("jkMwL");


var $2qYWP = parcelRequire("2qYWP");

const $fe42529edd9dec5e$var$AsyncSelect = /*#__PURE__*/ (0, $cozmU.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $jkMwL.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $2qYWP.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3X3EV.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fe42529edd9dec5e$export$2e2bcd8739ae039 = $fe42529edd9dec5e$var$AsyncSelect;
module.exports["default"] = $fe42529edd9dec5e$export$2e2bcd8739ae039;

});

parcelRegister("3X3EV", function(module, exports) {
/* select.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

function $e2a83d2c832246af$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $e2a83d2c832246af$var$isIPhone() {
    return $e2a83d2c832246af$var$testPlatform(/^iPhone/i);
}
function $e2a83d2c832246af$var$isIPad() {
    return $e2a83d2c832246af$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $e2a83d2c832246af$var$isMac() && navigator.maxTouchPoints > 1;
}
function $e2a83d2c832246af$var$isMac() {
    return $e2a83d2c832246af$var$testPlatform(/^Mac/i);
}
function $e2a83d2c832246af$var$isIOS() {
    return $e2a83d2c832246af$var$isIPhone() || $e2a83d2c832246af$var$isIPad();
}
function $e2a83d2c832246af$export$e1865c3bedcd822b() {
    return $e2a83d2c832246af$var$isMac() || $e2a83d2c832246af$var$isIOS();
}



var $7kFxw = parcelRequire("7kFxw");


var $dpsRj = parcelRequire("dpsRj");


var $iODl6 = parcelRequire("iODl6");


var $iDrrr = parcelRequire("iDrrr");


var $l9ukq = parcelRequire("l9ukq");

/* dummy-input.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");




const $2d6cb6d8ded15819$var$removeProps = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $2d6cb6d8ded15819$var$dummyInputStyles = null;
function $2d6cb6d8ded15819$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = $2d6cb6d8ded15819$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear'); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        ref: innerRef,
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2uo31fdnbC _30huDKdnbC _1xC2CJpl7Y _2xIroY98eZ _497WNwYbGa _2zndICdnbC _39xV02HZdu _1mT5xdRAKS _3U2PsZjOvk _1UtDYzjOvk _3iC0zdvcBI _1YKVNsdnbC _1VJPcaG8T7",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}








const $0dc13d4070494870$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");




const $5cadb6bbae063b3e$var$styles = null;
const $5cadb6bbae063b3e$var$A11yText = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span" // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKdnbC _4bt5LAnQyn _2WAcuGnQyn _39xV02HZdu _0jFU0VHZdu _1mT5xdWVPG _42Yu6BA6TK _1C7BHPdEFh _20VacPYbGa _1ANEUSLRg7",
            "-a11yText"
        ]),
        ...props
    });
var $5cadb6bbae063b3e$export$2e2bcd8739ae039 = $5cadb6bbae063b3e$var$A11yText;


const $cf09ff68c567883e$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $cozmU.useMemo)(()=>({
            ...(0, $0dc13d4070494870$export$a7265767c78f9bae),
            ...ariaLiveMessages
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $cozmU.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $cozmU.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5cadb6bbae063b3e$export$2e2bcd8739ae039), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5cadb6bbae063b3e$export$2e2bcd8739ae039), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cf09ff68c567883e$export$2e2bcd8739ae039 = $cf09ff68c567883e$var$LiveRegion;












var $310h3 = parcelRequire("310h3");

const $2c7f5c4bf8d5037d$var$noop = (0, $dpsRj.default);
function $2c7f5c4bf8d5037d$var$getScrollParent(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $2c7f5c4bf8d5037d$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $2c7f5c4bf8d5037d$var$normalizedHeight(el) {
    if ($2c7f5c4bf8d5037d$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $2c7f5c4bf8d5037d$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($2c7f5c4bf8d5037d$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $2c7f5c4bf8d5037d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $2c7f5c4bf8d5037d$var$getScrollTop(el) {
    if ($2c7f5c4bf8d5037d$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $2c7f5c4bf8d5037d$var$animatedScrollTo(element, to, duration = 200, callback = $2c7f5c4bf8d5037d$var$noop) {
    const start = $2c7f5c4bf8d5037d$var$getScrollTop(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $2c7f5c4bf8d5037d$var$easeOutCubic(currentTime, start, change, duration);
        $2c7f5c4bf8d5037d$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $2c7f5c4bf8d5037d$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = $2c7f5c4bf8d5037d$var$getScrollParent(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : $2c7f5c4bf8d5037d$var$normalizedHeight(scrollParent);
    const scrollTop = $2c7f5c4bf8d5037d$var$getScrollTop(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $2c7f5c4bf8d5037d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $2c7f5c4bf8d5037d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $2c7f5c4bf8d5037d$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $2c7f5c4bf8d5037d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $2c7f5c4bf8d5037d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $2c7f5c4bf8d5037d$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $2c7f5c4bf8d5037d$var$MenuPlacer = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $cozmU.useContext)((0, $310h3.PortalPlacementContext)) || {};
    const ref = (0, $cozmU.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $cozmU.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $cozmU.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $cozmU.useLayoutEffect)(()=>{
        // When the menu is hosted in the browser top layer, positioning, flipping
        // and viewport-fit are all handled by `@atlaskit/top-layer`. The placer
        // becomes a pass-through that only forwards `maxMenuHeight` as a cap.
        if ((0, $iDrrr.fg)('platform-dst-top-layer')) return;
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $2c7f5c4bf8d5037d$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $2c7f5c4bf8d5037d$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
var $2c7f5c4bf8d5037d$export$2e2bcd8739ae039 = $2c7f5c4bf8d5037d$var$MenuPlacer;



var $lSrYn = parcelRequire("lSrYn");

/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $312d6cd6268ed29a$export$f4da216a6ca54656 = (group)=>group.label;



var $bJjSn = parcelRequire("bJjSn");


var $kskvm = parcelRequire("kskvm");

/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $23f9642fe3df7275$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $23f9642fe3df7275$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$23f9642fe3df7275$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}



var $hNobR = parcelRequire("hNobR");

function $4bf658c2f5849ba4$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}



var $70HV3 = parcelRequire("70HV3");

function $d4f6ae23391d9f86$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}



var $5Tdig = parcelRequire("5Tdig");

function $8007bffd16fcb4f7$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    (0, $5Tdig.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}


/* required-input.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");







const $57b92616b4a43e5e$var$styles = null;
const $57b92616b4a43e5e$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_39xV02N91d _1mT5xdWVPG _1ZB6UydnbC _1OKFqYdnbC _3iC0zddnbC _1YKVNsdnbC _1pp6NdYbGa",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        value: "",
        onChange: (0, $dpsRj.default)
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $57b92616b4a43e5e$export$2e2bcd8739ae039 = $57b92616b4a43e5e$var$RequiredInput;











// ==============================
// Passive Event Detector
// ==============================



const $e49696561ee7bcce$var$noop = (0, $dpsRj.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $e49696561ee7bcce$var$passiveOptionAccessed = false;
const $e49696561ee7bcce$var$options = {
    get passive () {
        return $e49696561ee7bcce$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $e49696561ee7bcce$var$w = typeof window !== 'undefined' ? window : {};
if ($e49696561ee7bcce$var$w.addEventListener && $e49696561ee7bcce$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $e49696561ee7bcce$var$w.addEventListener('p', $e49696561ee7bcce$var$noop, $e49696561ee7bcce$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $e49696561ee7bcce$var$w.removeEventListener('p', $e49696561ee7bcce$var$noop, false);
}
const $e49696561ee7bcce$export$b0622a6911dbeaf5 = $e49696561ee7bcce$var$passiveOptionAccessed;


const $9b8f925ccf96b434$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $9b8f925ccf96b434$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $cozmU.useRef)(false);
    const isTop = (0, $cozmU.useRef)(false);
    const touchStart = (0, $cozmU.useRef)(0);
    const scrollTarget = (0, $cozmU.useRef)(null);
    const handleEventDelta = (0, $cozmU.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $9b8f925ccf96b434$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $cozmU.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $cozmU.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $cozmU.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $cozmU.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $e49696561ee7bcce$export$b0622a6911dbeaf5) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $cozmU.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}





const $88d66ae1308422f9$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $88d66ae1308422f9$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $88d66ae1308422f9$var$preventTouchMove(e) {
    e.preventDefault();
}
function $88d66ae1308422f9$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $88d66ae1308422f9$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $88d66ae1308422f9$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $88d66ae1308422f9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $88d66ae1308422f9$var$activeScrollLocks = 0;
const $88d66ae1308422f9$var$listenerOptions = {
    capture: false,
    passive: false
};
function $88d66ae1308422f9$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $cozmU.useRef)({});
    const scrollTarget = (0, $cozmU.useRef)(null);
    const addScrollLock = (0, $cozmU.useCallback)((touchScrollTarget)=>{
        if (!$88d66ae1308422f9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $88d66ae1308422f9$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $88d66ae1308422f9$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($88d66ae1308422f9$var$LOCK_STYLES).forEach((key)=>{
                const val = $88d66ae1308422f9$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $88d66ae1308422f9$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $88d66ae1308422f9$var$preventTouchMove, $88d66ae1308422f9$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $88d66ae1308422f9$var$preventInertiaScroll, $88d66ae1308422f9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $88d66ae1308422f9$var$allowTouchMove, $88d66ae1308422f9$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $88d66ae1308422f9$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $cozmU.useCallback)((touchScrollTarget)=>{
        if (!$88d66ae1308422f9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $88d66ae1308422f9$var$activeScrollLocks = Math.max($88d66ae1308422f9$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $88d66ae1308422f9$var$activeScrollLocks < 1) $88d66ae1308422f9$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $88d66ae1308422f9$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $88d66ae1308422f9$var$preventTouchMove, $88d66ae1308422f9$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $88d66ae1308422f9$var$preventInertiaScroll, $88d66ae1308422f9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $88d66ae1308422f9$var$allowTouchMove, $88d66ae1308422f9$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}


const $43596bd475aeda63$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $43596bd475aeda63$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $9b8f925ccf96b434$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $88d66ae1308422f9$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                onClick: $43596bd475aeda63$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}



function $89b76ef2cfe44086$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $4bf658c2f5849ba4$export$d8a62a489b442872)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}



var $22s7D = parcelRequire("22s7D");

function $14fb42ad8f3c150c$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}



var $aeRIw = parcelRequire("aeRIw");

/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $049c42a667ab2997$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;


function $fdb5147fd7c82020$var$_defineProperty(e, r, t) {
    return (r = $fdb5147fd7c82020$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fdb5147fd7c82020$var$_toPropertyKey(t) {
    var i = $fdb5147fd7c82020$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fdb5147fd7c82020$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fdb5147fd7c82020$var$noop = (0, $dpsRj.default);
function $fdb5147fd7c82020$var$notNullish(item) {
    return item != null;
}
function $fdb5147fd7c82020$var$scrollIntoView(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $89b76ef2cfe44086$export$3f99968195accfaf)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $89b76ef2cfe44086$export$3f99968195accfaf)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $fdb5147fd7c82020$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch  {
        return false;
    }
}
function $fdb5147fd7c82020$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch  {
        return false;
    }
} /**
   * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
   * @param styles - The styles object to filter.
   * @returns A new object containing only supported styles.
   */ 
const $fdb5147fd7c82020$var$filterUnsupportedSelectors = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
const $fdb5147fd7c82020$var$elemBeforeCSS = null; // Matches the duration of `motion.label.exit`; used only if a consumer render path
// unmounts the exiting values before their motion completion callback can run.
const $fdb5147fd7c82020$var$MULTI_VALUE_EXIT_FALLBACK_DURATION_MS = 100;
const $fdb5147fd7c82020$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $fdb5147fd7c82020$var$isTouchCapable(),
    captureMenuScroll: !$fdb5147fd7c82020$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $lSrYn.createFilter)(),
    formatGroupLabel: (0, $312d6cd6268ed29a$export$f4da216a6ca54656),
    getOptionLabel: (0, $bJjSn.getOptionLabel),
    getOptionValue: (0, $kskvm.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $049c42a667ab2997$export$56bd0c8d90db075),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$fdb5147fd7c82020$var$isMobileDevice(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $fdb5147fd7c82020$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $fdb5147fd7c82020$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $fdb5147fd7c82020$var$isOptionSelected(props, option, selectValue);
    const label = $fdb5147fd7c82020$var$getOptionLabel(props, option);
    const value = $fdb5147fd7c82020$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $fdb5147fd7c82020$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$fdb5147fd7c82020$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$fdb5147fd7c82020$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $fdb5147fd7c82020$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $fdb5147fd7c82020$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($fdb5147fd7c82020$var$notNullish);
}
function $fdb5147fd7c82020$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $fdb5147fd7c82020$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $fdb5147fd7c82020$var$buildFocusableOptions(props, selectValue) {
    return $fdb5147fd7c82020$var$buildFocusableOptionsFromCategorizedOptions($fdb5147fd7c82020$var$buildCategorizedOptions(props, selectValue));
}
function $fdb5147fd7c82020$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$fdb5147fd7c82020$var$shouldHideSelectedOptions(props) || !isSelected) && $fdb5147fd7c82020$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $fdb5147fd7c82020$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $fdb5147fd7c82020$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $fdb5147fd7c82020$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $fdb5147fd7c82020$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $fdb5147fd7c82020$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $fdb5147fd7c82020$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $fdb5147fd7c82020$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $fdb5147fd7c82020$var$getOptionValue(props, option);
    return selectValue.some((i)=>$fdb5147fd7c82020$var$getOptionValue(props, i) === candidate);
}
function $fdb5147fd7c82020$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $fdb5147fd7c82020$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $fdb5147fd7c82020$var$instanceId = 1; // eslint-disable-next-line @repo/internal/react/no-class-components, @atlaskit/volt-strict-mode/no-multiple-exports
class $fdb5147fd7c82020$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $hNobR.cleanValue)(value);
        let isTagMotionEnabled = false;
        if (isMulti) {
            const ffTagUplifts = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
            const ffTagMotion = (0, $iDrrr.fg)('platform-dst-motion-uplift-labels');
            isTagMotionEnabled = props.components?.MultiValue === undefined && props.components?.MultiValueContainer === undefined && ffTagUplifts && ffTagMotion;
        }
        const hasCompletedMultiValueExit = selectValue.length > 0 ? false : state.hasCompletedMultiValueExit;
        const isMultiValueExiting = isTagMotionEnabled && selectValue.length === 0 && !hasCompletedMultiValueExit && (state.isMultiValueExiting || state.selectValue.length > 0 && value !== prevProps?.value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $fdb5147fd7c82020$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $fdb5147fd7c82020$var$buildFocusableOptionsWithIds($fdb5147fd7c82020$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $fdb5147fd7c82020$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $fdb5147fd7c82020$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $fdb5147fd7c82020$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $aeRIw.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus,
            isMultiValueExiting: isMultiValueExiting,
            hasCompletedMultiValueExit: hasCompletedMultiValueExit
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $fdb5147fd7c82020$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps, prevState) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        // A consumer can cause the value subtree to unmount while the final tags are exiting.
        // The fallback keeps the placeholder out for the exit duration, then restores it even
        // when the individual MultiValue completion callback cannot fire.
        if (!prevState.isMultiValueExiting && this.state.isMultiValueExiting) this.multiValueExitFallbackTimeout = setTimeout(()=>{
            this.onMultiValueMotionFinish();
        }, $fdb5147fd7c82020$var$MULTI_VALUE_EXIT_FALLBACK_DURATION_MS);
        else if (prevState.isMultiValueExiting && !this.state.isMultiValueExiting) {
            if (this.multiValueExitFallbackTimeout) {
                clearTimeout(this.multiValueExitFallbackTimeout);
                this.multiValueExitFallbackTimeout = null;
            }
        }
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            $fdb5147fd7c82020$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
        if (this.multiValueExitFallbackTimeout) {
            clearTimeout(this.multiValueExitFallbackTimeout);
            this.multiValueExitFallbackTimeout = null;
        }
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    /**
   * Whether to defer the menu open until the in-flight click completes.
   * Any renderer that drives a `popover="auto"` element must, otherwise
   * the browser's light-dismiss can close the menu during the opening
   * gesture. Today only the top-layer path needs it.
   */ shouldDeferOpenUntilClick() {
        return (0, $iDrrr.fg)('platform-dst-top-layer');
    }
    /**
   * Open the menu after the current click, instead of
   * synchronously inside `mousedown`.
   *
   * On the top-layer path the menu is a `popover="auto"` element. The
   * browser performs light-dismiss during the pointer gesture. Deferring
   * until `click` ensures light-dismiss has completed before the popover opens.
   * Off the top-layer path we open synchronously as before.
   */ openMenuAfterClick(focusOption) {
        if (!this.shouldDeferOpenUntilClick()) {
            this.openMenu(focusOption);
            return;
        }
        this.openAfterClick = focusOption;
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $7kFxw.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            this.inputRef?.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) this.inputRef?.setAttribute('aria-label', normalizedLabel);
                else this.inputRef?.removeAttribute('aria-label');
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options?.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options?.find((option)=>{
            const groupCandidate = option;
            return groupCandidate.options?.some(isOptionFocused) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            const totalLength = options?.reduce((acc, currentGroup)=>{
                const group = currentGroup;
                acc += group?.options?.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData?.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options?.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0;
        // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $fdb5147fd7c82020$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $fdb5147fd7c82020$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $fdb5147fd7c82020$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        }
        // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
        // and no custom Option component is provided (custom Option components may already
        // render elemBefore themselves, causing it to appear twice)
        if (context === 'menu' && !this.props.formatOptionLabel && !this.props.components?.Option && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const elemBefore = data.elemBefore;
            if (elemBefore) {
                const label = this.getOptionLabel(data);
                return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                    className: (0, $hekY6.default)([
                        "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
                    ]),
                    children: [
                        elemBefore,
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            children: label
                        })
                    ]
                });
            }
        }
        return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const isDisabledA11yFixEnabled = (0, $iDrrr.fg)('platform_dst_select_disabled_a11y_fix'); // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            ...!this.props.isSearchable && (0, $iDrrr.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                'aria-autocomplete': 'both'
            },
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && !(0, $iDrrr.fg)('select_issearchable_aria-readonly_fix') && {
                'aria-readonly': true
            },
            // Using aria-disabled so the element remains in the a11y tree.
            ...isDisabledA11yFixEnabled && {
                'aria-disabled': isDisabled || undefined
            },
            ...this.calculateDescription()
        };
        const effectiveTabIndex = isDisabledA11yFixEnabled && isDisabled ? -1 : tabIndex;
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2d6cb6d8ded15819$export$2e2bcd8739ae039), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: $fdb5147fd7c82020$var$noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: effectiveTabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
         // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, $8aG6j.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: effectiveTabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        const renderMultiValues = (isMotionEnabled = false)=>selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return /*#__PURE__*/ (0, $cozmU.createElement)(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    isMotionEnabled: isMotionEnabled,
                    onMotionFinish: this.onMultiValueMotionFinish,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        },
                        ...testId && {
                            'data-testid': `${testId}-select--multivalue-${index}-remove`
                        },
                        id: `${this.getElementId('selected-value')}-${index}-remove`
                    },
                    data: opt,
                    innerProps: {
                        ...testId && {
                            'data-testid': `${testId}-select--multivalue-${index}`
                        },
                        id: `${this.getElementId('selected-value')}-${index}`
                    }
                }, this.formatOptionLabel(opt, 'value'));
            });
        const placeholderElement = inputValue ? null : /*#__PURE__*/ (0, $cozmU.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) {
            const ffTagUplifts = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
            const ffTagMotion = (0, $iDrrr.fg)('platform-dst-motion-uplift-labels');
            const isTagMotionEnabled = this.props.components?.MultiValue === undefined && this.props.components?.MultiValueContainer === undefined && ffTagUplifts && ffTagMotion;
            if (isTagMotionEnabled) return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
                        children: controlShouldRenderValue ? renderMultiValues(true) : null
                    }),
                    (!this.hasValue() || !controlShouldRenderValue) && !this.state.isMultiValueExiting && placeholderElement
                ]
            });
            if (!this.hasValue() || !controlShouldRenderValue) return placeholderElement;
            return renderMultiValues();
        }
        if (!this.hasValue() || !controlShouldRenderValue) return placeholderElement;
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $8aG6j.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value'),
                // Hide from AT so the value is only announced via aria-describedby on the combobox.
                ...isDisabled && (0, $iDrrr.fg)('platform_dst_select_disabled_a11y_fix') && {
                    'aria-hidden': true
                }
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            // Always hidden: DropdownIndicator hoists aria-hidden onto consumer-supplied
            // children only, keeping the voice-control button visible to AT.
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
         // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $cozmU.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $cozmU.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $8aG6j.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $8aG6j.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...this.props['UNSAFE_is_experimental_generic'] && {
                        role: 'listitem'
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2c7f5c4bf8d5037d$export$2e2bcd8739ae039), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $8aG6j.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $43596bd475aeda63$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $8aG6j.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': this.inputRef?.id || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $7kFxw.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': this.inputRef?.id || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        }); // On the top-layer path the menu always portals (into the top layer)
        // regardless of consumer `menuPortalTarget` / `menuPosition`. Off the
        // flag we keep the legacy "portal only when needed" behaviour.
        const shouldPortal = (0, $iDrrr.fg)('platform-dst-top-layer') || menuPortalTarget || menuPosition === 'fixed';
        if (!shouldPortal) return menuElement;
         // Top-layer path needs the state mirror so MenuPortalTopLayer re-renders
        // when the anchor attaches; legacy path keeps the direct ref read.
        const controlElementForPortal = (0, $iDrrr.fg)('platform-dst-top-layer') ? this.state.controlElement : this.controlRef;
        const menuPortal = /*#__PURE__*/ (0, $8aG6j.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: controlElementForPortal,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }); // The Provider plumbs the close signal to MenuPortalTopLayer; not
        // needed on the legacy path.
        if (!(0, $iDrrr.fg)('platform-dst-top-layer')) return menuPortal;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $70HV3.MenuPortalCloseContext).Provider, {
            value: this.handleOpenLayerObserverCloseSignal,
            children: menuPortal
        });
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $57b92616b4a43e5e$export$2e2bcd8739ae039), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cf09ff68c567883e$export$2e2bcd8739ae039), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $22s7D.SelectGetStylesContext).Provider, {
            value: this.getStyles,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown,
                    ...testId && {
                        'data-testid': testId && `${testId}-select--container`
                    }
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                children: [
                    this.renderLiveRegion(),
                    commonProps.isMulti && this.renderMultiselectMessage(),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)(Control, {
                        ...commonProps,
                        innerRef: this.getControlRef,
                        innerProps: {
                            onMouseDown: this.onControlMouseDown,
                            onClick: this.onControlClick,
                            onTouchEnd: this.onControlTouchEnd,
                            ...testId && {
                                'data-testid': `${testId}-select--control`
                            }
                        },
                        appearance: appearance,
                        isInvalid: isInvalid,
                        isDisabled: isDisabled,
                        isFocused: isFocused,
                        menuIsOpen: menuIsOpen,
                        isCompact: isCompact,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsxs)(ValueContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                isCompact: isCompact,
                                hasValue: commonProps.hasValue || this.state.isMultiValueExiting,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--value-container`
                                    },
                                    ...commonProps.isMulti && commonProps.hasValue && !(0, $e2a83d2c832246af$export$e1865c3bedcd822b)() && {
                                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                        // DST Accessibility.
                                        role: 'application'
                                    }
                                },
                                children: [
                                    this.renderPlaceholderOrValue(),
                                    this.renderInput()
                                ]
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsxs)(IndicatorsContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--indicators-container`
                                    }
                                },
                                children: [
                                    this.renderClearIndicator(),
                                    this.renderLoadingIndicator(),
                                    this.renderDropdownIndicator()
                                ]
                            })
                        ]
                    }),
                    this.renderMenu(),
                    this.renderFormField(),
                    !(0, $iDrrr.fg)('platform-dst-top-layer') && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8007bffd16fcb4f7$export$17baa7c95b6ba1b8), {
                        isOpen: this.props.menuIsOpen,
                        onClose: this.handleOpenLayerObserverCloseSignal
                    })
                ]
            })
        });
    }
    // Lifecycle
    // ------------------------------
    constructor(_props){
        super(_props);
        $fdb5147fd7c82020$var$_defineProperty(this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            controlElement: null,
            isMultiValueExiting: false,
            hasCompletedMultiValueExit: false
        }); // Misc. Instance Properties
        // ------------------------------
        $fdb5147fd7c82020$var$_defineProperty(this, "blockOptionHover", false);
        $fdb5147fd7c82020$var$_defineProperty(this, "isComposing", false);
        $fdb5147fd7c82020$var$_defineProperty(this, "commonProps", void 0); // TODO
        $fdb5147fd7c82020$var$_defineProperty(this, "initialTouchX", 0);
        $fdb5147fd7c82020$var$_defineProperty(this, "initialTouchY", 0);
        $fdb5147fd7c82020$var$_defineProperty(this, "openAfterFocus", false);
        $fdb5147fd7c82020$var$_defineProperty(this, "openAfterClick", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "scrollToFocusedOptionOnUpdate", false);
        $fdb5147fd7c82020$var$_defineProperty(this, "multiValueExitFallbackTimeout", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "userIsDragging", void 0); // Refs
        // ------------------------------
        $fdb5147fd7c82020$var$_defineProperty(this, "controlRef", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "getControlRef", (ref)=>{
            this.controlRef = ref; // Mirror the ref into state on the top-layer path so
            // `MenuPortalTopLayer`'s layout effects react to the anchor attaching.
            // Skip the null-ref (unmount) case: setState during unmount is unsafe
            // and the state is dropped with the instance anyway.
            if (ref === null) return;
            if (this.state.controlElement !== ref && (0, $iDrrr.fg)('platform-dst-top-layer')) this.setState({
                controlElement: ref
            });
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "focusedOptionRef", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "getFocusedOptionRef", (ref)=>{
            this.focusedOptionRef = ref;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "menuListRef", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "getMenuListRef", (ref)=>{
            this.menuListRef = ref;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "inputRef", null);
        $fdb5147fd7c82020$var$_defineProperty(this, "getInputRef", (ref)=>{
            this.inputRef = ref;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onMultiValueMotionFinish", ()=>{
            if (this.state.isMultiValueExiting) this.setState({
                isMultiValueExiting: false,
                hasCompletedMultiValueExit: true,
                selectValue: []
            });
        }); // aliased for consumers
        $fdb5147fd7c82020$var$_defineProperty(this, "focus", this.focusInput);
        $fdb5147fd7c82020$var$_defineProperty(this, "blur", this.blurInput);
        $fdb5147fd7c82020$var$_defineProperty(this, "onControlClick", ()=>{
            const focusOption = this.openAfterClick;
            this.openAfterClick = null;
            if (focusOption && !this.props.menuIsOpen) this.openMenu(focusOption);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onChange", (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "setValue", (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "selectOption", (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $d4f6ae23391d9f86$export$d1ca752ec761b95b)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $d4f6ae23391d9f86$export$d1ca752ec761b95b)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $14fb42ad8f3c150c$export$dea4763e29237f4c)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $14fb42ad8f3c150c$export$dea4763e29237f4c)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "removeValue", (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $aeRIw.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "clearValue", ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $aeRIw.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "popValue", ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $aeRIw.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }); // ==============================
        // Getters
        // ==============================
        $fdb5147fd7c82020$var$_defineProperty(this, "getFocusedOptionId", (focusedOption)=>{
            return $fdb5147fd7c82020$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getFocusableOptionsWithIds", ()=>{
            return $fdb5147fd7c82020$var$buildFocusableOptionsWithIds($fdb5147fd7c82020$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getValue", ()=>this.state.selectValue);
        $fdb5147fd7c82020$var$_defineProperty(this, "cx", (...args)=>(0, $23f9642fe3df7275$export$ce4ab0c55987d1ff)(this.props.classNamePrefix, ...args));
        $fdb5147fd7c82020$var$_defineProperty(this, "getOptionLabel", (data)=>{
            return $fdb5147fd7c82020$var$getOptionLabel(this.props, data);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getOptionValue", (data)=>{
            return $fdb5147fd7c82020$var$getOptionValue(this.props, data);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getStyles", (key, props)=>{
            const base = {
                boxSizing: 'border-box'
            };
            const custom = this.props.styles[key];
            if (custom) return $fdb5147fd7c82020$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getClassNames", (key, props)=>this.props.classNames[key]?.(props));
        $fdb5147fd7c82020$var$_defineProperty(this, "getElementId", (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "getComponents", ()=>{
            return (0, $l9ukq.defaultComponents)(this.props);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "buildCategorizedOptions", ()=>$fdb5147fd7c82020$var$buildCategorizedOptions(this.props, this.state.selectValue));
        $fdb5147fd7c82020$var$_defineProperty(this, "getCategorizedOptions", ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : []);
        $fdb5147fd7c82020$var$_defineProperty(this, "buildFocusableOptions", ()=>$fdb5147fd7c82020$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()));
        $fdb5147fd7c82020$var$_defineProperty(this, "getFocusableOptions", ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : []); // ==============================
        // Helpers
        // ==============================
        $fdb5147fd7c82020$var$_defineProperty(this, "ariaOnChange", (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }); // ==============================
        // Mouse Handlers
        // ==============================
        $fdb5147fd7c82020$var$_defineProperty(this, "onMenuMouseDown", (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onMenuMouseMove", (_)=>{
            this.blockOptionHover = false;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onControlMouseDown", (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenuAfterClick('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onDropdownIndicatorMouseDown", (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenuAfterClick('first');
            event.preventDefault();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onClearIndicatorMouseDown", (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onScroll", (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $4bf658c2f5849ba4$export$d8a62a489b442872)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onCompositionStart", ()=>{
            this.isComposing = true;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onCompositionEnd", ()=>{
            this.isComposing = false;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onTouchStart", ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onTouchMove", ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onTouchEnd", (event)=>{
            if (this.userIsDragging) return;
             // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
             // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onControlTouchEnd", (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onClearIndicatorTouchEnd", (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onDropdownIndicatorTouchEnd", (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }); // ==============================
        // Focus Handlers
        // ==============================
        $fdb5147fd7c82020$var$_defineProperty(this, "handleInputChange", (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onInputFocus", (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) {
                // `openAfterFocus` always follows a pointer gesture, so defer until
                // click. `openMenuOnFocus` alone can come from a keyboard tab
                // with no pointer gesture in flight, so open synchronously.
                if (this.openAfterFocus) this.openMenuAfterClick('first');
                else this.openMenu('first');
            }
            this.openAfterFocus = false;
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onInputBlur", (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $iDrrr.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "onOptionHover", (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "shouldHideSelectedOptions", ()=>{
            return $fdb5147fd7c82020$var$shouldHideSelectedOptions(this.props);
        }); // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        $fdb5147fd7c82020$var$_defineProperty(this, "onValueInputFocus", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }); // ==============================
        // Keyboard Handlers
        // ==============================
        $fdb5147fd7c82020$var$_defineProperty(this, "onKeyDown", (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            } // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if ((0, $iDrrr.fg)('platform-dst-top-layer')) {
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            return;
                        }
                        if (isClearable && escapeClearsValue) {
                            this.clearValue();
                            return;
                        } // Native auto popovers own every Escape on the top-layer path.
                        // The active popover consumes the close request and synchronizes
                        // menuIsOpen through its onClose bridge.
                        return;
                    }
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        $fdb5147fd7c82020$var$_defineProperty(this, "handleOpenLayerObserverCloseSignal", ()=>{
            this.onMenuClose();
        });
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$fdb5147fd7c82020$var$instanceId);
        this.state.selectValue = (0, $hNobR.cleanValue)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $fdb5147fd7c82020$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
}
$fdb5147fd7c82020$var$_defineProperty($fdb5147fd7c82020$export$2e2bcd8739ae039, "defaultProps", $fdb5147fd7c82020$export$9c21a3269931e1e6);
module.exports["default"] = $fdb5147fd7c82020$export$2e2bcd8739ae039;

});

parcelRegister("l9ukq", function(module, exports) {
/* indicators-container.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $k4Jbz = parcelRequire("k4Jbz");

const $f0e53d9860be0f9c$var$indicatorContainerStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $f0e53d9860be0f9c$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _4xdlr0FlnN _03SyCP1Y8M",
            (0, $k12R1.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};


/* multi-value-container.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");







const $82bd5a0be9dfbcd5$var$multiValueStyles = {
    root: "_0bjKvDKxmn _3vBAKHT3oA _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _4ouGXIPgdg _43nrzTFQfX _2xTnZxFQfX _0rIjykFQfX _0GTcwRFQfX _0KLXru7Cj1 _1EqgXlN91d _1UtDYzy7kJ _0gdQWVYbGa",
    disabled: "_1UtDYzot27 _0KLXruDMqu",
    focused: "_1UtDYzjTy9 _0KLXruY9q9 _2OUyjtUbsb _33VGdrNvrM _0s2BChjOvk _4zUdn16wH8"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $82bd5a0be9dfbcd5$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...innerProps,
        className: (0, $hekY6.default)([
            $82bd5a0be9dfbcd5$var$multiValueStyles.root,
            isDisabled && $82bd5a0be9dfbcd5$var$multiValueStyles.disabled,
            isFocused && $82bd5a0be9dfbcd5$var$multiValueStyles.focused,
            (0, $k12R1.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};


/* select-container.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");










const $2694c143d6fa36b9$var$containerStyles = {
    default: "_2sNsIg20Hp _1mT5xdRAKS _1pp6NdYsOL _4kBIzkmnOE",
    rtl: "_3kIIylu2Pf",
    disabled: "_0wOv4Qsyl5"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $2694c143d6fa36b9$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $k4Jbz.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            $2694c143d6fa36b9$var$containerStyles.default,
            isRtl && $2694c143d6fa36b9$var$containerStyles.rtl,
            isDisabled && $2694c143d6fa36b9$var$containerStyles.disabled,
            (0, $k12R1.cx)(className, xcss, '-container')
        ]),
        style: css,
        ...innerProps,
        children: children
    });
};


/* value-container.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");








var $iDrrr = parcelRequire("iDrrr");




const $f24b89d672307c2d$var$valueContainerStyles = {
    default: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _3iDTPbgBM8 _3TGfC9HnLE _0xWutCdqJc _1mT5xdRAKS _03SyCPgVvo _0LQT5EgVvo",
    verticalPaddingStandard: "_46hvQmFQfX _0xmtkoFQfX",
    verticalPaddingTagUpliftMulti: "_46hvQm1Y8M _0xmtko1Y8M",
    verticalPaddingTagUpliftCompactMulti: "_46hvQmFQfX _0xmtkoFQfX",
    verticalPaddingCompactNonUplift: "_46hvQmPgdg _0xmtkoPgdg",
    flex: "_3iDTPbQ4SZ",
    flexWithGap: "_2mHwu81Y8M _3iDTPbQ4SZ _3TGfC9HnLE"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $f24b89d672307c2d$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    const ffTagUplifts = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const tagUpliftMultiVertical = ffTagUplifts && isMulti;
    const tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            $f24b89d672307c2d$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $f24b89d672307c2d$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $f24b89d672307c2d$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $f24b89d672307c2d$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $f24b89d672307c2d$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $f24b89d672307c2d$var$valueContainerStyles.flex,
            tagUpliftChipRow && $f24b89d672307c2d$var$valueContainerStyles.flexWithGap,
            (0, $k12R1.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css,
        ...innerProps,
        children: children
    });
};


/* control.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 


parcelRequire("cozmU");













const $9f1050d22f191849$var$styles = {
    default: "_2xIroY98eZ _497WNwYbGa _2zndICdnbC _0bjKvDKTcp _23rrnH5Vpu _3vBAKHHKt7 _3hxITi6wH8 _2V7sgONvrM _0hPCNLDIqT _0wOv4Q18ZR _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuI7V3 _1mT5xdRAKS _0KLXru7Cj1 _4kiQYAUF4f _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _2KFbDKJg58 _3ILZpPJg58 _1gVfwBYbGa _4mPnyfjXjE _0hPERGHKt7 _2vSjE56m9C _0ReiIH7zJH _1eOmH6qWX3 _3ZpBalCmBb",
    compact: "_4kiQYAUofl",
    invalid: "_3vBAKHnod9 _2OUyjtFKgL _4mPnyfFKgL _0hPERGnod9",
    focusedInvalid: "_2OUyjtPhRM",
    disabled: "_3vBAKHVrZW _1pp6NdYbGa _0KLXruVrZW _4mPnyfwcEu",
    focused: "_3vBAKHnXvL _0KLXruutHW _2OUyjtPhRM _4mPnyfPhRM _0hPERGnXvL _1eOmH6utHW",
    subtle: "_3vBAKHjOvk _0KLXrujOvk _4mPnyfw5zn",
    subtleFocused: "_0KLXrulfZc",
    none: "_3vBAKHjOvk _0KLXrujOvk _4mPnyfw5zn _0hPERGjOvk _1eOmH6jOvk"
};
const $9f1050d22f191849$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: innerRef,
        className: (0, $hekY6.default)([
            $9f1050d22f191849$var$styles.default,
            isDisabled && $9f1050d22f191849$var$styles.disabled,
            isInvalid && $9f1050d22f191849$var$styles.invalid,
            isCompact && $9f1050d22f191849$var$styles.compact,
            appearance === 'subtle' && $9f1050d22f191849$var$styles.subtle,
            appearance === 'subtle' && isFocused && $9f1050d22f191849$var$styles.subtleFocused,
            isFocused && $9f1050d22f191849$var$styles.focused,
            appearance === 'none' && $9f1050d22f191849$var$styles.none,
            (0, $k12R1.cx)(className, xcss, '-control')
        ]),
        style: css,
        ...innerProps,
        "aria-disabled": (0, $iDrrr.fg)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9f1050d22f191849$export$2e2bcd8739ae039 = $9f1050d22f191849$var$Control;



var $1qwbX = parcelRequire("1qwbX");

/* group-heading.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");










// Clean Common Props
// ==============================
const $f2a94cc1b8ddb584$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: // not listed in commonProps documentation, needs to be removed to allow Emotion to generate classNames
    clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: // not listed in commonProps documentation
    selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};


const $83df16e577cd0423$var$headingStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $83df16e577cd0423$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $f2a94cc1b8ddb584$export$8e9fd4287627890c)(props);
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbvLZJ _1UtDYzZpcK _0wOv4Q18ZR _1kk5Tkmb2E _0rIjykMKEk _03SyCP8HPE _0LQT5E8HPE _41LZZBYbGa",
            (0, $k12R1.cx)(className, xcss, '-group')
        ]),
        style: css,
        ...innerProps
    });
};


/* clear-indicator.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");








var $5avUB = parcelRequire("5avUB");





var $hBYtq = parcelRequire("hBYtq");




const $5a5651cd1854e8b7$var$iconContainerStyles = {
    root: "_1mb4UnZqHV _2xIroY98eZ _497WNwDHe6 _2zndICT6kp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _46hvQmFQfX _03SyCPFQfX _0xmtkoFQfX _0LQT5EFQfX"
};
const $5a5651cd1854e8b7$var$clearIndicatorStyles = {
    default: "_23rrnHYru2 _3iDTPbQ4SZ _1UtDYzKGUX _46hvQmgVvo _03SyCPFQfX _0xmtkogVvo _0LQT5EFQfX _0clgaMZpcK",
    compact: "_46hvQmdnbC _0xmtkodnbC",
    finesse: "_1UtDYz4YkS _0clgaM8ujp"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $5a5651cd1854e8b7$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $5a5651cd1854e8b7$var$clearIndicatorStyles.default,
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && $5a5651cd1854e8b7$var$clearIndicatorStyles.finesse,
            isCompact && $5a5651cd1854e8b7$var$clearIndicatorStyles.compact,
            (0, $k12R1.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            xcss: $5a5651cd1854e8b7$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
};


/* dropdown-indicator.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");








var $7sJoX = parcelRequire("7sJoX");





var $1l0kj = parcelRequire("1l0kj");






const $a1cf7e8114f3e508$var$dropdownWrapperStyles = {
    root: "_46hvQmgVvo _03SyCPgVvo _0xmtkogVvo _0LQT5EgVvo"
}; // Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
const $a1cf7e8114f3e508$var$voiceControlPressableStyles = {
    root: "_4c065UdnbC _2Y7lL4dnbC _3SamIHdnbC _2YLqiKdnbC _0KLXrujOvk _3iDTPbQ4SZ _0hPCNLDIqT"
}; // Inline size reset applied as a last resort (see the `style` prop docs on
// @atlaskit/primitives). Consumers ship global element selectors such as
// `& button { min-width: 149px }` (e.g. Jira Plans' hierarchy filter — see
// https://hello.jira.atlassian.cloud/jira/browse/JPO-42328) whose (class +
// element) specificity outranks the atomic single-class styles above, stretching
// this button and pushing the chevron toward the middle of the control. Inline
// styles outrank any selector, so the button always hugs the chevron and stays
// right-aligned like the gate-off icon-in-a-div.
const $a1cf7e8114f3e508$var$voiceControlPressableSizeReset = {
    minWidth: 0,
    width: 'auto'
};
const $a1cf7e8114f3e508$var$dropdownStyles = {
    default: "_23rrnHYru2 _3iDTPbQ4SZ _1UtDYzZpcK _46hvQmgVvo _03SyCPFQfX _0xmtkogVvo _0LQT5EFQfX _0clgaMZpcK",
    compact: "_46hvQmdnbC _0xmtkodnbC",
    disabled: "_1UtDYzot27",
    finesse: "_1UtDYz4YkS",
    finesseDisabled: "_1UtDYzoM2E"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $a1cf7e8114f3e508$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps = {}, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    const { 'aria-hidden': ariaHidden, ...restInnerProps } = innerProps;
    const isVoiceControlAccessible = (0, $iDrrr.fg)('platform_dst_select_dropdown_voice_control'); // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    const wrapperTestId = restInnerProps['data-testid'] ? `${restInnerProps['data-testid']}-children` : undefined;
    const voiceControlAccessibleIndicator = children ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId,
        children: children
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: $a1cf7e8114f3e508$var$voiceControlPressableStyles.root,
        style: $a1cf7e8114f3e508$var$voiceControlPressableSizeReset,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            as: "span",
            xcss: $a1cf7e8114f3e508$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $a1cf7e8114f3e508$var$dropdownStyles.default,
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && $a1cf7e8114f3e508$var$dropdownStyles.finesse,
            isDisabled && $a1cf7e8114f3e508$var$dropdownStyles.disabled,
            isDisabled && (0, $iDrrr.fg)('platform-dst-tokens-finesse') && $a1cf7e8114f3e508$var$dropdownStyles.finesseDisabled,
            isCompact && $a1cf7e8114f3e508$var$dropdownStyles.compact,
            (0, $k12R1.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...restInnerProps,
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden,
        children: isVoiceControlAccessible ? voiceControlAccessibleIndicator : children ?? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            as: "span",
            xcss: $a1cf7e8114f3e508$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
};


/* loading-indicator.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");








var $lfoFx = parcelRequire("lfoFx");




const $55ae1ff552b4e887$var$loadingIndicatorStyles = {
    default: "_46hvQmgVvo _03SyCP2ADO _0xmtkogVvo _0LQT5E2ADO",
    compact: "_46hvQmdnbC _0xmtkodnbC"
};
const $55ae1ff552b4e887$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $55ae1ff552b4e887$var$loadingIndicatorStyles.default,
            isCompact && $55ae1ff552b4e887$var$loadingIndicatorStyles.compact,
            (0, $k12R1.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            size: "small"
        })
    });
};


/* input.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");














const $4f7020a25ebba73d$var$inputStylesOld = {
    root: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _1xC2CJpl7Y _3SamIHFQfX _2YLqiKFQfX _4c065UFQfX _3iDTPbkfkE _2iEGP2uU7u _1UtDYzy7kJ _1gHrEndnbC _35LzqndnbC _3hlIN9dnbC _1G7t7NdnbC _21xcc5dnbC _4bqSyPdnbC _0sKA2cdnbC _3Ico7NdnbC _0YfYpCdnbC _3vZWbIOLYo _0Psg1qIjUK _4z3m3Q98eZ _3W3NEwYbGa _4dPioddnbC _4DX2ez4Jdh _0GBAIrkWHv _22EsJjnQyn _47WczEZYee",
    disabled: "_0fKRyPnQyn",
    labellingFFStyles: "_2sNsIg7NXe _3SamIHPgdg _2YLqiKPgdg _4c065UPgdg"
};
const $4f7020a25ebba73d$var$inputStyles = {
    root: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _1xC2CJpl7Y _3SamIHFQfX _2YLqiKFQfX _4c065UFQfX _1mT5xdRAKS _3iDTPbQ4SZ _2iEGP2uU7u _1UtDYzy7kJ _1gHrEndnbC _35LzqndnbC _3hlIN9dnbC _1G7t7NdnbC _21xcc5dnbC _4bqSyPdnbC _0sKA2cdnbC _3Ico7NdnbC _0YfYpCdnbC _3vZWbIOLYo _0Psg1qIjUK _4z3m3Q98eZ _3W3NEwYbGa _4dPioddnbC _4DX2ez4Jdh _0GBAIrkWHv _22EsJjnQyn _47WczEZYee",
    disabled: "_0fKRyPnQyn",
    labellingFFStyles: "_2sNsIg7NXe _3SamIHPgdg _2YLqiKPgdg _4c065UPgdg"
};
const $4f7020a25ebba73d$var$nativeInputStylesOld = null;
const $4f7020a25ebba73d$var$nativeInputStyles = null;
const $4f7020a25ebba73d$var$hidden = null;
const $4f7020a25ebba73d$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss, isMulti: isMulti } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $f2a94cc1b8ddb584$export$8e9fd4287627890c)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'input', {
        'input-container': true
    });
    const ffTagUplifts = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $iDrrr.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $4f7020a25ebba73d$var$inputStyles.root,
            isMulti && ffTagUplifts && $4f7020a25ebba73d$var$inputStyles.labellingFFStyles,
            isDisabled && $4f7020a25ebba73d$var$inputStyles.disabled,
            (0, $k12R1.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("input" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        , {
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _49OCfRdnbC _2uo31fdnbC _30huDKdnbC _2sNsIgOLYo _1xC2CJIjUK _2xIroY98eZ _497WNwYbGa _2zndICdnbC _39xV02N91d _4ouGXI4Jdh _1mT5xdWVPG _1UtDYzOLYo _1YKVNs7dHp",
                isHidden && "_1YKVNsdnbC",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $4f7020a25ebba73d$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $4f7020a25ebba73d$var$inputStylesOld.labellingFFStyles,
            isDisabled && $4f7020a25ebba73d$var$inputStylesOld.disabled,
            (0, $k12R1.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("input" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        , {
            className: (0, $hekY6.default)([
                "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2uo31fdnbC _30huDKdnbC _2sNsIgOLYo _1xC2CJIjUK _2xIroY98eZ _497WNwYbGa _2zndICdnbC _39xV02N91d _4ouGXI4Jdh _1UtDYzOLYo _1YKVNs7dHp",
                isHidden && "_1YKVNsdnbC",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $4f7020a25ebba73d$export$2e2bcd8739ae039 = $4f7020a25ebba73d$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");










const $1b5d001d71e5bc28$var$menuStyles = {
    root: "_0bjKvD8fU6 _1mT5xdWVPG _39xV02N91d _42Yu6B7dHp _0rIjyk2ADO _43nrzT2ADO _0KLXruoI2d _2OUyjtGk8v",
    bottom: "_2I62gzN91d",
    top: "_1ZB6UyN91d"
};
const $1b5d001d71e5bc28$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            $1b5d001d71e5bc28$var$menuStyles.root,
            $1b5d001d71e5bc28$var$menuStyles[placement],
            (0, $k12R1.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $1b5d001d71e5bc28$export$2e2bcd8739ae039 = $1b5d001d71e5bc28$var$Menu;


/* menu-list.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");










const $49c6cef5c6ffc437$var$menuListStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $49c6cef5c6ffc437$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _2WAcuGIZbP _0xmtko2ADO _46hvQm2ADO _0xWutCdqJc",
            (0, $k12R1.cx)(className, xcss, '-MenuList')
        ]),
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};


/* menu-loading-message.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");








var $4aRua = parcelRequire("4aRua");




const $5eb1baed63c9b197$var$noticeStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $5eb1baed63c9b197$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            "_0xmtko2ADO _46hvQm2ADO _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT",
            (0, $k12R1.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css,
        ...innerProps,
        role: "option",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text.subtle",
            children: children
        })
    });
};


/* menu-no-options-message.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");













const $77e0ef38afccad04$var$noticeStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $77e0ef38afccad04$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            "_0xmtko2ADO _46hvQm2ADO _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT",
            (0, $k12R1.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text.subtle",
            children: children
        })
    });
};



var $1aBuU = parcelRequire("1aBuU");

/* multi-value.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");








var $64L5u = parcelRequire("64L5u");





var $IOtUu = parcelRequire("IOtUu");




/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $cozmU = parcelRequire("cozmU");


var $22s7D = parcelRequire("22s7D");

const $b44a4f40086e07f5$export$2a533455c10aa11f = ()=>(0, $cozmU.useContext)((0, $22s7D.SelectGetStylesContext));



/* multi-value-label.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");







const $eb10c4bb8401dbff$var$multiValueLabelStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDcjp5 _2sNsIgmnOE _1ANEUSLRg7 _03SyCPFQfX _0LQT5E1Y8M _1UtDYzOLYo",
    disabled: "_1UtDYzot27",
    ellipsis: "_39HuIbz8Lp"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $eb10c4bb8401dbff$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...innerProps,
        className: (0, $hekY6.default)([
            $eb10c4bb8401dbff$var$multiValueLabelStyles.root,
            isDisabled && $eb10c4bb8401dbff$var$multiValueLabelStyles.disabled,
            hasEllipsis && $eb10c4bb8401dbff$var$multiValueLabelStyles.ellipsis,
            (0, $k12R1.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};


const $f872b998c5f0f390$var$multiValueTagWrapperStyles = {
    root: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _3SamIHPgdg _2YLqiKPgdg _0hPCNLDIqT _3iDTPbQ4SZ _4ouGXIPgdg _2kO3ta7dHp _23x1DK7dHp _2C4fi9AEMG _0fdRYlDIqT _0ReY56Q4SZ _412qNSPgdg"
};
const $f872b998c5f0f390$var$multiValueMotionStyles = {
    active: "_4bt5LAnQyn _2WAcuGnQyn _0yKXXaecOK",
    entering: "_2fBhtesJLy _39Ohv4YbGa",
    exiting: "_2fBhte8C1u _39Ohv4YbGa"
}; // Tag-like color styles
const $f872b998c5f0f390$var$tagLikeColorStyles = {
    gray: "_2ssR4FiXlq",
    blue: "_2ssR4F432W",
    green: "_2ssR4FWIYU",
    red: "_2ssR4FDVsW",
    yellow: "_2ssR4FKuhU",
    purple: "_2ssR4FrKVc",
    lime: "_2ssR4Fb94u",
    magenta: "_2ssR4FULTZ",
    orange: "_2ssR4FPz9H",
    teal: "_2ssR4FMMwr"
};
const $f872b998c5f0f390$var$tagLikeBorderFilterStyles = null; // Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
const $f872b998c5f0f390$var$multiValueTagLikeStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _2sNsIg7NXe _3hxITi6wH8 _2V7sgONvrM _3SamIHPgdg _2YLqiKPgdg _3iDTPbccYA _24h04i2Njc _1mT5xdRAKS _0hPCNLDIqT _4xdlr0DIqT _4ouGXIPgdg _3YEZNO7dHp _1EqgXl6zFX _0jFU0VbKFA _0KLXru66of _1UtDYzy7kJ _0wOv4Q18ZR _0gdQWVYbGa",
    labelWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIPgdg _4kiQYAdnbC _09lPhhOLYo",
    disabled: "_1UtDYzot27 _0KLXruDMqu",
    focused: "_1UtDYzjTy9 _0KLXruo126 _2OUyjtUbsb _33VGdrNvrM _0s2BChjOvk _4zUdn16wH8"
};
const $f872b998c5f0f390$var$getMultiValueLabelText = (children, data)=>{
    if (typeof children === 'string') return children;
    const label = data?.label;
    return typeof label === 'string' ? label : '';
};
const $f872b998c5f0f390$var$MultiValueContent = (contentProps)=>{
    const { multiValueProps: props, motionRef: motionRef, motionState: motionState } = contentProps;
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const labelText = $f872b998c5f0f390$var$getMultiValueLabelText(children, data);
    const isPlainLabel = typeof children === 'string';
    const ffTagUplifts = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const isEnteringWithMotion = motionState === 'entering';
    const isExitingWithMotion = motionState === 'exiting';
    const { css: containerCss, className: containerClassName } = (0, $k4Jbz.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $k4Jbz.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $k4Jbz.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    const hasCustomLabel = Label !== (0, $eb10c4bb8401dbff$export$544aeea2a5ce08ee);
    const hasCustomContainer = Container !== (0, $82bd5a0be9dfbcd5$export$cf9cf2a30a59265c);
    const selectStyles = selectProps.styles;
    const hasCustomMultiValueStyles = Boolean(selectStyles?.multiValue || selectStyles?.multiValueLabel || selectStyles?.multiValueRemove);
    const selectClassNames = selectProps.classNames;
    const hasCustomMultiValueClassNames = Boolean(selectClassNames?.multiValue || selectClassNames?.multiValueLabel || selectClassNames?.multiValueRemove); // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    const selectGetStyles = (0, $b44a4f40086e07f5$export$2a533455c10aa11f)();
    const hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    const hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        const { elemBefore: elemBefore, color: tagColor } = data ?? {};
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...innerProps,
            ref: motionRef,
            className: (0, $hekY6.default)([
                $f872b998c5f0f390$var$multiValueTagWrapperStyles.root,
                isExitingWithMotion && $f872b998c5f0f390$var$multiValueMotionStyles.active,
                isExitingWithMotion && $f872b998c5f0f390$var$multiValueMotionStyles.exiting,
                (0, $k12R1.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $IOtUu.default), {
                text: labelText,
                isRemovable: !isDisabled,
                removeButtonLabel: `${labelText}, remove`,
                onBeforeRemoveAction: ()=>{
                    removeProps.onClick?.({});
                    return false;
                },
                color: tagColor ?? 'gray',
                elemBefore: elemBefore,
                hasMargin: false
            })
        });
    } // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        const colorKey = data?.color;
        return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            "data-multi-value-tag-like": "true",
            ...innerProps,
            ref: motionRef,
            style: containerCss,
            className: (0, $hekY6.default)([
                $f872b998c5f0f390$var$multiValueTagLikeStyles.root,
                $f872b998c5f0f390$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $f872b998c5f0f390$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $f872b998c5f0f390$var$tagLikeColorStyles.green,
                colorKey === 'red' && $f872b998c5f0f390$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $f872b998c5f0f390$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $f872b998c5f0f390$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $f872b998c5f0f390$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $f872b998c5f0f390$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $f872b998c5f0f390$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $f872b998c5f0f390$var$tagLikeColorStyles.teal,
                "_3vBAKHvQ39",
                isDisabled && $f872b998c5f0f390$var$multiValueTagLikeStyles.disabled,
                isFocused && $f872b998c5f0f390$var$multiValueTagLikeStyles.focused,
                (isEnteringWithMotion || isExitingWithMotion) && $f872b998c5f0f390$var$multiValueMotionStyles.active,
                isEnteringWithMotion && $f872b998c5f0f390$var$multiValueMotionStyles.entering,
                isExitingWithMotion && $f872b998c5f0f390$var$multiValueMotionStyles.exiting,
                (0, $k12R1.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        $f872b998c5f0f390$var$multiValueTagLikeStyles.labelWrapper
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Label, {
                        data: data,
                        innerProps: {
                            style: labelCss,
                            className: labelClassName
                        },
                        className: labelClassName,
                        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                        selectProps: selectProps,
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)(Remove, {
                    data: data,
                    innerProps: {
                        style: removeCss,
                        className: removeClassName,
                        role: 'button',
                        tabIndex: -1,
                        'aria-label': `${labelText || 'option'}, remove`,
                        ...removeProps
                    },
                    className: removeClassName,
                    isDisabled: isDisabled,
                    selectProps: selectProps
                })
            ]
        });
    } // FF off → default styles
    return /*#__PURE__*/ (0, $8aG6j.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${labelText || 'option'}, remove`,
                    ...removeProps
                },
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
const $f872b998c5f0f390$var$MotionMultiValue = (props)=>{
    const { multiValueProps: multiValueProps } = props;
    const { ref: ref, state: state } = (0, $64L5u.useMotion)({
        onFinish: (motionState)=>{
            if (motionState === 'exiting') multiValueProps.onMotionFinish?.();
        }
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($f872b998c5f0f390$var$MultiValueContent, {
        multiValueProps: multiValueProps,
        motionRef: ref,
        motionState: state
    });
};
const $f872b998c5f0f390$var$MultiValue = (props)=>{
    if (props.isMotionEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)($f872b998c5f0f390$var$MotionMultiValue, {
        multiValueProps: props
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($f872b998c5f0f390$var$MultiValueContent, {
        multiValueProps: props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $f872b998c5f0f390$export$2e2bcd8739ae039 = $f872b998c5f0f390$var$MultiValue;



/* multi-value-remove.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");








var $l3wuH = parcelRequire("l3wuH");

const $f40c950c9b8482e4$var$disabledStyles = null;
const $f40c950c9b8482e4$var$enabledStyles = null;
const $f40c950c9b8482e4$var$multiValueRemoveStyles = {
    focused: "_0KLXrucZWP _1rdFvhjTy9",
    root: "_30huDKYbGa _0bjKvDKxmn _0hPCNLDIqT _37wbyuDIqT _4xdlr0DIqT _034jHtYbGa _0KLXru66of _1UtDYzy7kJ _3iDTPbQ4SZ _1rdFvhy7kJ _46hvQmFQfX _03SyCPFQfX _0xmtkoFQfX _0LQT5EFQfX _2xTnZxFQfX _34b3D2pgTj _1eOmH6o126 _2AVwAQAyGJ _3gzVzLN4oS _1cgZWFAyGJ"
};
function $f40c950c9b8482e4$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...innerProps,
        className: (0, $hekY6.default)([
            $f40c950c9b8482e4$var$multiValueRemoveStyles.root,
            isFocused && $f40c950c9b8482e4$var$multiValueRemoveStyles.focused,
            (0, $k12R1.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $hekY6.default)([
                isDisabled && "_3iDTPbYbGa",
                !isDisabled && "_3iDTPbOLYo"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
}


/* option.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");













const $d398d66bfaec3d5a$var$optionStyles = {
    root: "_4c065UgVvo _2Y7lL48HPE _1UtDYzy7kJ _0wOv4Q18ZR _3iDTPbvLZJ _4ya3eEOLYo _39xV02N91d _20VacPYbGa _2X4BecWrS5 _3gzVzLN4oS",
    disabled: "_1UtDYzot27 _0wOv4Qsyl5 _0KLXrujOvk _2OUyjtYbGa _3gzVzLjOvk _2rG9p6YbGa",
    focused: "_0KLXruo126 _2OUyjtsKwa _2rG9p6TjXh",
    finesseFocused: "_2OUyjtYbGa _2rG9p6YbGa",
    selected: "_1UtDYzjTy9 _0KLXruY9q9 _2OUyjtsKwa _3gzVzLXsxn _2rG9p6TjXh",
    focusedSelected: "_0KLXrusumd",
    motion: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
    motionSelected: "_23rrnHWE38 _1B4rbIo10F"
};
const $d398d66bfaec3d5a$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $d398d66bfaec3d5a$var$optionStyles.root,
            !isDisabled && !isSelected && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $d398d66bfaec3d5a$var$optionStyles.motion,
            isFocused && $d398d66bfaec3d5a$var$optionStyles.focused,
            isFocused && !isSelected && (0, $iDrrr.fg)('platform-dst-tokens-finesse') && $d398d66bfaec3d5a$var$optionStyles.finesseFocused,
            isSelected && $d398d66bfaec3d5a$var$optionStyles.selected,
            isFocused && isSelected && $d398d66bfaec3d5a$var$optionStyles.focusedSelected,
            !isDisabled && isSelected && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $d398d66bfaec3d5a$var$optionStyles.motionSelected,
            isDisabled && $d398d66bfaec3d5a$var$optionStyles.disabled,
            (0, $k12R1.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $d398d66bfaec3d5a$export$2e2bcd8739ae039 = $d398d66bfaec3d5a$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");













const $16deef2071d68a24$var$placeholderStyles = {
    root: "_1xC2CJpl7Y _43nrzTdnbC _2xTnZxFQfX _0rIjykdnbC _0GTcwRFQfX _1UtDYzKGUX",
    disabled: "_1UtDYzot27",
    finesse: "_1UtDYzZpcK"
};
const $16deef2071d68a24$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $16deef2071d68a24$var$placeholderStyles.root,
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && $16deef2071d68a24$var$placeholderStyles.finesse,
            isDisabled && $16deef2071d68a24$var$placeholderStyles.disabled,
            (0, $k12R1.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$16deef2071d68a24$export$2e2bcd8739ae039 = $16deef2071d68a24$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v3.0.1 */ 


parcelRequire("cozmU");










const $cf350c196e5d2294$var$styles = {
    root: "_1xC2CJpl7Y _4bt5LAnQyn _2WAcuGnQyn _1EqgXlN91d _39HuIbz8Lp _1ANEUSLRg7 _43nrzTdnbC _2xTnZxFQfX _0rIjykdnbC _0GTcwRFQfX _1UtDYzy7kJ",
    disalbed: "_1UtDYzot27"
};
const $cf350c196e5d2294$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $hekY6.default)([
            $cf350c196e5d2294$var$styles.root,
            isDisabled && $cf350c196e5d2294$var$styles.disalbed,
            (0, $k12R1.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $cf350c196e5d2294$export$2e2bcd8739ae039 = $cf350c196e5d2294$var$SingleValue;


const $2d42c92553201638$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $5a5651cd1854e8b7$export$ecf9cf59142dd54a),
    Control: (0, $9f1050d22f191849$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $a1cf7e8114f3e508$export$ec98719d3db7f2e4),
    Group: (0, $1qwbX.default),
    GroupHeading: (0, $83df16e577cd0423$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $f0e53d9860be0f9c$export$d0ffd7e649cab6f),
    Input: (0, $4f7020a25ebba73d$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $55ae1ff552b4e887$export$7c20be4c1d342248),
    Menu: (0, $1b5d001d71e5bc28$export$2e2bcd8739ae039),
    MenuList: (0, $49c6cef5c6ffc437$export$d4c4e98c5044dc8),
    MenuPortal: (0, $1aBuU.MenuPortal),
    LoadingMessage: (0, $5eb1baed63c9b197$export$e928a71d039d3102),
    NoOptionsMessage: (0, $77e0ef38afccad04$export$d58b72b7d3c4072c),
    MultiValue: (0, $f872b998c5f0f390$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $82bd5a0be9dfbcd5$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $eb10c4bb8401dbff$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $f40c950c9b8482e4$export$8e1fd1a40e7a2f4a),
    Option: (0, $d398d66bfaec3d5a$export$2e2bcd8739ae039),
    Placeholder: (0, $16deef2071d68a24$export$2e2bcd8739ae039),
    SelectContainer: (0, $2694c143d6fa36b9$export$446eebadefe1123b),
    SingleValue: (0, $cf350c196e5d2294$export$2e2bcd8739ae039),
    ValueContainer: (0, $f24b89d672307c2d$export$4dc9f58ad9a1a000)
};
const $2d42c92553201638$export$71abc632aa29e6fe = (props)=>({
        ...$2d42c92553201638$export$9b5ac10f59f76296,
        ...props.components
    });
module.exports["components"] = $2d42c92553201638$export$9b5ac10f59f76296;
module.exports["defaultComponents"] = $2d42c92553201638$export$71abc632aa29e6fe;

});

parcelRegister("1qwbX", function(module, exports) {
/* group.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");


var $k4Jbz = parcelRequire("k4Jbz");

const $d71fedd0ebda1298$var$styles = {
    root: "_0xmtko2ADO _46hvQm2ADO"
};
const $d71fedd0ebda1298$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        ...innerProps,
        className: (0, $hekY6.default)([
            $d71fedd0ebda1298$var$styles.root,
            (0, $k12R1.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $8aG6j.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                children: children
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d71fedd0ebda1298$export$2e2bcd8739ae039 = $d71fedd0ebda1298$var$Group;
module.exports["default"] = $d71fedd0ebda1298$export$2e2bcd8739ae039;

});

parcelRegister("1aBuU", function(module, exports) {
/* menu-portal.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $k12R1 = parcelRequire("k12R1");




var $ihhlg = parcelRequire("ihhlg");

function $e0fbb449e8f98fd3$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $ihhlg.getSideAxis)(placement);
    const alignmentAxis = (0, $ihhlg.getAlignmentAxis)(placement);
    const alignLength = (0, $ihhlg.getAxisLength)(alignmentAxis);
    const side = (0, $ihhlg.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $ihhlg.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $e0fbb449e8f98fd3$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $ihhlg.evaluate)(options, state);
    const paddingObject = (0, $ihhlg.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $ihhlg.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $ihhlg.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $e0fbb449e8f98fd3$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $e0fbb449e8f98fd3$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $e0fbb449e8f98fd3$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $e0fbb449e8f98fd3$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $e0fbb449e8f98fd3$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $e0fbb449e8f98fd3$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e0fbb449e8f98fd3$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $ihhlg.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $ihhlg.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $ihhlg.getAlignmentAxis)(placement);
            const length = (0, $ihhlg.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $ihhlg.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $ihhlg.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $ihhlg.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $ihhlg.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $e0fbb449e8f98fd3$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $ihhlg.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $ihhlg.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $ihhlg.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $ihhlg.getAlignment)(placement) === alignment || (autoAlignment ? (0, $ihhlg.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $e0fbb449e8f98fd3$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $ihhlg.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $ihhlg.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $ihhlg.placements) ? $e0fbb449e8f98fd3$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $ihhlg.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $ihhlg.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $ihhlg.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $ihhlg.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $e0fbb449e8f98fd3$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $ihhlg.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $ihhlg.getSide)(placement);
            const initialSideAxis = (0, $ihhlg.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $ihhlg.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $ihhlg.getOppositePlacement)(initialPlacement)
            ] : (0, $ihhlg.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $ihhlg.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $ihhlg.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $ihhlg.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $ihhlg.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $ihhlg.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $e0fbb449e8f98fd3$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $e0fbb449e8f98fd3$var$isAnySideFullyClipped(overflow) {
    return (0, $ihhlg.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $e0fbb449e8f98fd3$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $ihhlg.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $e0fbb449e8f98fd3$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $e0fbb449e8f98fd3$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $e0fbb449e8f98fd3$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $e0fbb449e8f98fd3$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $e0fbb449e8f98fd3$var$getBoundingRect(rects) {
    const minX = (0, $ihhlg.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $ihhlg.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $ihhlg.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $ihhlg.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $e0fbb449e8f98fd3$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $ihhlg.rectToClientRect)($e0fbb449e8f98fd3$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $e0fbb449e8f98fd3$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $ihhlg.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $e0fbb449e8f98fd3$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $ihhlg.rectToClientRect)($e0fbb449e8f98fd3$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $ihhlg.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $ihhlg.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $ihhlg.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $ihhlg.getSide)(placement) === 'left';
                    const maxRight = (0, $ihhlg.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $ihhlg.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $e0fbb449e8f98fd3$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $e0fbb449e8f98fd3$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $ihhlg.getSide)(placement);
    const alignment = (0, $ihhlg.getAlignment)(placement);
    const isVertical = (0, $ihhlg.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $e0fbb449e8f98fd3$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $ihhlg.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $e0fbb449e8f98fd3$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $e0fbb449e8f98fd3$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $e0fbb449e8f98fd3$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $ihhlg.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $ihhlg.getSideAxis)((0, $ihhlg.getSide)(placement));
            const mainAxis = (0, $ihhlg.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $ihhlg.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $ihhlg.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $e0fbb449e8f98fd3$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $ihhlg.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $ihhlg.getSideAxis)(placement);
            const mainAxis = (0, $ihhlg.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $ihhlg.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $e0fbb449e8f98fd3$var$originSides.has((0, $ihhlg.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $e0fbb449e8f98fd3$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $ihhlg.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $ihhlg.getSide)(placement);
            const alignment = (0, $ihhlg.getAlignment)(placement);
            const isYAxis = (0, $ihhlg.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $ihhlg.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $ihhlg.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $ihhlg.max)(overflow.left, 0);
                const xMax = (0, $ihhlg.max)(overflow.right, 0);
                const yMin = (0, $ihhlg.max)(overflow.top, 0);
                const yMax = (0, $ihhlg.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $ihhlg.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $ihhlg.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};






var $3tq6j = parcelRequire("3tq6j");

function $7551f9448d197224$var$getCssDimensions(element) {
    const css = (0, $3tq6j.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $3tq6j.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $ihhlg.round)(width) !== offsetWidth || (0, $ihhlg.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $7551f9448d197224$var$unwrapElement(element) {
    return !(0, $3tq6j.isElement)(element) ? element.contextElement : element;
}
function $7551f9448d197224$var$getScale(element) {
    const domElement = $7551f9448d197224$var$unwrapElement(element);
    if (!(0, $3tq6j.isHTMLElement)(domElement)) return (0, $ihhlg.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $7551f9448d197224$var$getCssDimensions(domElement);
    let x = ($ ? (0, $ihhlg.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $ihhlg.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $7551f9448d197224$var$noOffsets = /*#__PURE__*/ (0, $ihhlg.createCoords)(0);
function $7551f9448d197224$var$getVisualOffsets(element) {
    const win = (0, $3tq6j.getWindow)(element);
    if (!(0, $3tq6j.isWebKit)() || !win.visualViewport) return $7551f9448d197224$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $7551f9448d197224$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $3tq6j.getWindow)(element)) return false;
    return isFixed;
}
function $7551f9448d197224$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $7551f9448d197224$var$unwrapElement(element);
    let scale = (0, $ihhlg.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $3tq6j.isElement)(offsetParent)) scale = $7551f9448d197224$var$getScale(offsetParent);
        } else scale = $7551f9448d197224$var$getScale(element);
    }
    const visualOffsets = $7551f9448d197224$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $7551f9448d197224$var$getVisualOffsets(domElement) : (0, $ihhlg.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $3tq6j.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $3tq6j.isElement)(offsetParent) ? (0, $3tq6j.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $3tq6j.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $7551f9448d197224$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $3tq6j.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $3tq6j.getWindow)(currentIFrame);
            currentIFrame = (0, $3tq6j.getFrameElement)(currentWin);
        }
    }
    return (0, $ihhlg.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $7551f9448d197224$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $3tq6j.getNodeScroll)(element).scrollLeft;
    if (!rect) return $7551f9448d197224$var$getBoundingClientRect((0, $3tq6j.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $7551f9448d197224$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $7551f9448d197224$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $7551f9448d197224$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $3tq6j.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $3tq6j.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $ihhlg.createCoords)(1);
    const offsets = (0, $ihhlg.createCoords)(0);
    const isOffsetParentAnElement = (0, $3tq6j.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3tq6j.getNodeName)(offsetParent) !== 'body' || (0, $3tq6j.isOverflowElement)(documentElement)) scroll = (0, $3tq6j.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $7551f9448d197224$var$getBoundingClientRect(offsetParent);
            scale = $7551f9448d197224$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $7551f9448d197224$var$getHTMLOffset(documentElement, scroll) : (0, $ihhlg.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $7551f9448d197224$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $7551f9448d197224$var$getDocumentRect(element) {
    const html = (0, $3tq6j.getDocumentElement)(element);
    const scroll = (0, $3tq6j.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $ihhlg.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $ihhlg.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $7551f9448d197224$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $3tq6j.getComputedStyle)(body).direction === 'rtl') x += (0, $ihhlg.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $7551f9448d197224$var$SCROLLBAR_MAX = 25;
function $7551f9448d197224$var$getViewportRect(element, strategy) {
    const win = (0, $3tq6j.getWindow)(element);
    const html = (0, $3tq6j.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $3tq6j.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $7551f9448d197224$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $7551f9448d197224$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $7551f9448d197224$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $7551f9448d197224$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $7551f9448d197224$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $3tq6j.isHTMLElement)(element) ? $7551f9448d197224$var$getScale(element) : (0, $ihhlg.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $7551f9448d197224$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $7551f9448d197224$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $7551f9448d197224$var$getDocumentRect((0, $3tq6j.getDocumentElement)(element));
    else if ((0, $3tq6j.isElement)(clippingAncestor)) rect = $7551f9448d197224$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $7551f9448d197224$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $ihhlg.rectToClientRect)(rect);
}
function $7551f9448d197224$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $3tq6j.getParentNode)(element);
    if (parentNode === stopNode || !(0, $3tq6j.isElement)(parentNode) || (0, $3tq6j.isLastTraversableNode)(parentNode)) return false;
    return (0, $3tq6j.getComputedStyle)(parentNode).position === 'fixed' || $7551f9448d197224$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $7551f9448d197224$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $3tq6j.getOverflowAncestors)(element, [], false).filter((el)=>(0, $3tq6j.isElement)(el) && (0, $3tq6j.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $3tq6j.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $3tq6j.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $3tq6j.isElement)(currentNode) && !(0, $3tq6j.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $3tq6j.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $3tq6j.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $3tq6j.isOverflowElement)(currentNode) && !currentNodeIsContaining && $7551f9448d197224$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $3tq6j.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $7551f9448d197224$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $3tq6j.isTopLayer)(element) ? [] : $7551f9448d197224$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $7551f9448d197224$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $7551f9448d197224$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $ihhlg.max)(rect.top, top);
        right = (0, $ihhlg.min)(rect.right, right);
        bottom = (0, $ihhlg.min)(rect.bottom, bottom);
        left = (0, $ihhlg.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $7551f9448d197224$var$getDimensions(element) {
    const { width: width, height: height } = $7551f9448d197224$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $7551f9448d197224$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $3tq6j.isHTMLElement)(offsetParent);
    const documentElement = (0, $3tq6j.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $7551f9448d197224$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $ihhlg.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $7551f9448d197224$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3tq6j.getNodeName)(offsetParent) !== 'body' || (0, $3tq6j.isOverflowElement)(documentElement)) scroll = (0, $3tq6j.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $7551f9448d197224$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $7551f9448d197224$var$getHTMLOffset(documentElement, scroll) : (0, $ihhlg.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $7551f9448d197224$var$isStaticPositioned(element) {
    return (0, $3tq6j.getComputedStyle)(element).position === 'static';
}
function $7551f9448d197224$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $3tq6j.isHTMLElement)(element) || (0, $3tq6j.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $3tq6j.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $7551f9448d197224$var$getOffsetParent(element, polyfill) {
    const win = (0, $3tq6j.getWindow)(element);
    if ((0, $3tq6j.isTopLayer)(element)) return win;
    if (!(0, $3tq6j.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $3tq6j.getParentNode)(element);
        while(svgOffsetParent && !(0, $3tq6j.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $3tq6j.isElement)(svgOffsetParent) && !$7551f9448d197224$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $3tq6j.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $7551f9448d197224$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $3tq6j.isTableElement)(offsetParent) && $7551f9448d197224$var$isStaticPositioned(offsetParent))offsetParent = $7551f9448d197224$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $3tq6j.isLastTraversableNode)(offsetParent) && $7551f9448d197224$var$isStaticPositioned(offsetParent) && !(0, $3tq6j.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $3tq6j.getContainingBlock)(element) || win;
}
const $7551f9448d197224$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $7551f9448d197224$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $7551f9448d197224$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $7551f9448d197224$var$isRTL(element) {
    return (0, $3tq6j.getComputedStyle)(element).direction === 'rtl';
}
const $7551f9448d197224$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $7551f9448d197224$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $3tq6j.getDocumentElement,
    getClippingRect: $7551f9448d197224$var$getClippingRect,
    getOffsetParent: $7551f9448d197224$var$getOffsetParent,
    getElementRects: $7551f9448d197224$var$getElementRects,
    getClientRects: $7551f9448d197224$var$getClientRects,
    getDimensions: $7551f9448d197224$var$getDimensions,
    getScale: $7551f9448d197224$var$getScale,
    isElement: $3tq6j.isElement,
    isRTL: $7551f9448d197224$var$isRTL
};
function $7551f9448d197224$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $7551f9448d197224$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $3tq6j.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $ihhlg.floor)(top);
        const insetRight = (0, $ihhlg.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $ihhlg.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $ihhlg.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $ihhlg.max)(0, (0, $ihhlg.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$7551f9448d197224$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $7551f9448d197224$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $7551f9448d197224$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $3tq6j.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $3tq6j.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $7551f9448d197224$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $7551f9448d197224$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $7551f9448d197224$var$getBoundingClientRect(reference);
        if (prevRefRect && !$7551f9448d197224$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $7551f9448d197224$export$37b6bde19b108ecc = (0, $e0fbb449e8f98fd3$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $7551f9448d197224$export$cc800923e997bb8 = (0, $e0fbb449e8f98fd3$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $7551f9448d197224$export$91fb6ecbd551914 = (0, $e0fbb449e8f98fd3$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $7551f9448d197224$export$fba63a578e423eb = (0, $e0fbb449e8f98fd3$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $7551f9448d197224$export$8a83211c878a3f1f = (0, $e0fbb449e8f98fd3$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $7551f9448d197224$export$346677f925de839c = (0, $e0fbb449e8f98fd3$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $7551f9448d197224$export$fe8985bb6374093c = (0, $e0fbb449e8f98fd3$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $7551f9448d197224$export$f2120bbfa5450bd2 = (0, $e0fbb449e8f98fd3$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $7551f9448d197224$export$18c8ad048e32c7d5 = (0, $e0fbb449e8f98fd3$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $7551f9448d197224$export$7bf07e38f3dc4b69 = (0, $e0fbb449e8f98fd3$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $7551f9448d197224$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $7551f9448d197224$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $e0fbb449e8f98fd3$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $9kbTQ = parcelRequire("9kbTQ");


var $iDrrr = parcelRequire("iDrrr");


var $k4Jbz = parcelRequire("k4Jbz");


var $310h3 = parcelRequire("310h3");

/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $5Tdig = parcelRequire("5Tdig");


var $kVXS3 = parcelRequire("kVXS3");


var $97Yf0 = parcelRequire("97Yf0");


var $hPK4E = parcelRequire("hPK4E");





var $70HV3 = parcelRequire("70HV3");

function $3e266eed0a999110$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
const $3e266eed0a999110$var$menuPortalStyles = {
    root: "_1BYlJIJavW"
}; /**
    * Top-layer host for react-select's menu. Hands positioning, flip, and width
    * to `@atlaskit/top-layer`; ignores `appendTo` / `menuPortalTarget` /
    * `menuPosition`. The browser-dismiss handler is supplied internally by
    * `Select` via `MenuPortalCloseContext`.
    *
    * @example
    * ```tsx
    * <MenuPortalTopLayer controlElement={el} menuPlacement="bottom">
    *   <Menu />
    * </MenuPortalTopLayer>
    * ```
    */ 
function $3e266eed0a999110$export$1f5427c7f5364d0b(props) {
    const { children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props; // Select's "close the menu" callback, distinct from `Popover.onClose`.
    const closeSelect = (0, $cozmU.useContext)((0, $70HV3.MenuPortalCloseContext));
    const popoverRef = (0, $cozmU.useRef)(null); // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    const anchorRef = (0, $cozmU.useRef)(null);
    anchorRef.current = controlElement; // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    const isAnchored = controlElement !== null; // `gap: 0` matches the legacy MenuPortal (no trigger-to-menu gap; the
    // menu root already declares its own `marginBlockStart`). Without this
    // override `useAnchorPosition`'s default 8px gap would diverge visually
    // from the legacy path.
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $3e266eed0a999110$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            offset: {
                gap: 0
            }
        },
        isOpen: isAnchored
    });
    (0, $hPK4E.useWidthFromAnchor)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        mode: 'match-anchor',
        isOpen: isAnchored
    });
    const handlePopoverClose = (0, $cozmU.useCallback)(()=>{
        if (closeSelect) closeSelect();
    }, [
        closeSelect
    ]); // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, $5Tdig.useNotifyOpenLayerObserver)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    }); // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    const { className: className } = (0, $k4Jbz.getStyleProps)({
        ...props,
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }, 'menuPortal', {
        'menu-portal': true
    });
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // `mode="auto"` delegates light-dismiss and Escape to the browser. The
    // `onClose` bridge then synchronizes react-select's `menuIsOpen` state after
    // native dismissal, keeping this popover available to consume the request.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    // Putting the role on the outer host caused Playwright `toBeVisible`
    // and some SR hit-testing to treat it as hidden (zero bounding rect
    // while `styles.root` opts out of UA `[popover]` positioning).
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kVXS3.Popover), {
        ref: popoverRef,
        mode: "auto",
        isOpen: isAnchored,
        onClose: handlePopoverClose,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // `className` carries consumer `styles.menuPortal({...})` output,
            // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
            // is a legacy selector hook kept for parity with MenuPortalLegacy.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
            className: (0, $hekY6.default)([
                $3e266eed0a999110$var$menuPortalStyles.root,
                (0, $k12R1.cx)(className, xcss, '-MenuPortal')
            ]),
            ...innerProps,
            children: children
        })
    });
}


function $b44269c50c53072b$var$getBoundingClientObj(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
const $b44269c50c53072b$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $b44269c50c53072b$var$menuPortalStyles = {
    root: "_42Yu6B7dHp _3iC0zd8knl _1mT5xdX4tw _2I62gz0MUb _39xV02wtpS"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
function $b44269c50c53072b$var$MenuPortalLegacy(props) {
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $cozmU.useRef)(null);
    const cleanupRef = (0, $cozmU.useRef)(null);
    const [placement, setPortalPlacement] = (0, $cozmU.useState)($b44269c50c53072b$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $cozmU.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $cozmU.useState)(null);
    const updateComputedPosition = (0, $cozmU.useCallback)(()=>{
        if (!controlElement) return;
        const rect = $b44269c50c53072b$var$getBoundingClientObj(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $cozmU.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $7551f9448d197224$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $cozmU.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]); // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $k4Jbz.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    }); // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $hekY6.default)([
            $b44269c50c53072b$var$menuPortalStyles.root,
            (0, $k12R1.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $310h3.PortalPlacementContext).Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $9kbTQ.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
}
const $b44269c50c53072b$export$793392f970497feb = (props)=>{
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3e266eed0a999110$export$1f5427c7f5364d0b), {
        ...props
    });
     // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b44269c50c53072b$var$MenuPortalLegacy, {
        ...props
    });
};
module.exports["MenuPortal"] = $b44269c50c53072b$export$793392f970497feb;

});

parcelRegister("lSrYn", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $d63abcda1284ac20$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $d63abcda1284ac20$var$anyDiacritic = new RegExp('[' + $d63abcda1284ac20$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $d63abcda1284ac20$var$diacriticToBase = {};
for(let i = 0; i < $d63abcda1284ac20$var$diacritics.length; i++){
    let diacritic = $d63abcda1284ac20$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$d63abcda1284ac20$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $d63abcda1284ac20$export$b5bee4b27048330b = (str)=>{
    return str.replace($d63abcda1284ac20$var$anyDiacritic, (match)=>$d63abcda1284ac20$var$diacriticToBase[match]);
};


const $6b1b0c551aa67178$var$memoizedStripDiacriticsForInput = (0, $dOBRD.default)((0, $d63abcda1284ac20$export$b5bee4b27048330b));
const $6b1b0c551aa67178$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $6b1b0c551aa67178$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $6b1b0c551aa67178$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $6b1b0c551aa67178$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $6b1b0c551aa67178$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $6b1b0c551aa67178$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $6b1b0c551aa67178$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $d63abcda1284ac20$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
module.exports["createFilter"] = $6b1b0c551aa67178$export$5d81789ff4aeccdf;

});

parcelRegister("bJjSn", function(module, exports) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $81a1c472cad5dd30$export$dac6ace3020563ca = (option)=>option.label;
module.exports["getOptionLabel"] = $81a1c472cad5dd30$export$dac6ace3020563ca;

});

parcelRegister("kskvm", function(module, exports) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $699dc714e415a23f$export$40be908210c5a79c = (option)=>option.value;
module.exports["getOptionValue"] = $699dc714e415a23f$export$40be908210c5a79c;

});

parcelRegister("hNobR", function(module, exports) {
const $c84c6644eee4f36c$export$33f062f47f21a01 = (value)=>{
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
module.exports["cleanValue"] = $c84c6644eee4f36c$export$33f062f47f21a01;

});

parcelRegister("aeRIw", function(module, exports) {
function $25c47531e63a634f$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
module.exports["valueTernary"] = $25c47531e63a634f$export$40fb9515c784cc3b;

});

parcelRegister("jkMwL", function(module, exports) {
$parcel$export(module.exports, "default", () => $44c0b8f7e58ea102$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $44c0b8f7e58ea102$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $44c0b8f7e58ea102$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $cozmU.useRef)(undefined);
    const mounted = (0, $cozmU.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $cozmU.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $cozmU.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $cozmU.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $cozmU.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $cozmU.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $cozmU.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $cozmU.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $cozmU.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $cozmU.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $cozmU.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $cozmU.useCallback)((newValue, actionMeta)=>{
        const inputValue = $44c0b8f7e58ea102$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("2qYWP", function(module, exports) {
$parcel$export(module.exports, "default", () => $582f0891543bc339$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $582f0891543bc339$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $cozmU.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $cozmU.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $cozmU.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $cozmU.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $cozmU.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $cozmU.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $cozmU.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});

parcelRegister("ggg0l", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $h6GPp = parcelRequire("h6GPp");

const $bbeb3f75bd6af510$export$53c2b9c37c40e0d8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (method, payload, channel)=>{
    const $ = (0, $bDgLe.c)(5);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const methodRef = (0, $h6GPp.useTrackedRef)(method);
    const payloadRef = (0, $h6GPp.useTrackedRef)(payload);
    let t0;
    if ($[0] !== channel || $[1] !== createAnalyticsEvent || $[2] !== methodRef || $[3] !== payloadRef) {
        t0 = (...t1)=>{
            const args = t1;
            const pload = typeof payloadRef.current === "function" ? payloadRef.current(...args) : payloadRef.current;
            createAnalyticsEvent(pload).fire(channel);
            methodRef.current(...args);
        };
        $[0] = channel;
        $[1] = createAnalyticsEvent;
        $[2] = methodRef;
        $[3] = payloadRef;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const methodRef = (0, $h6GPp.useTrackedRef)(method);
    const payloadRef = (0, $h6GPp.useTrackedRef)(payload);
    return (0, $cozmU.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};
module.exports["useCallbackWithAnalytics"] = $bbeb3f75bd6af510$export$53c2b9c37c40e0d8;

});

parcelRegister("aIOjp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $4dGdo = parcelRequire("4dGdo");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $kUXcd = parcelRequire("kUXcd");

/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $638c8511a917505b$var$ShrinkOut = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, duration: t1, onFinish: onFinish } = t0;
    const duration = t1 === undefined ? "small" : t1;
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const exiting = (0, $kUXcd.useExitingPersistence)();
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    const setTimeout = (0, $1U6E9.useSetTimeout)();
    const direction = exiting.isExiting ? "exiting" : "entering";
    let t2;
    if ($[0] !== duration || $[1] !== element || $[2] !== exiting || $[3] !== onFinish || $[4] !== requestAnimationFrame || $[5] !== setTimeout) {
        t2 = ()=>{
            if (exiting.isExiting && element) {
                if ((0, $jlWUB.isReducedMotion)()) {
                    exiting.onFinish && exiting.onFinish();
                    onFinish && onFinish("exiting");
                    return;
                }
                const newStyles = {
                    width: `${element.offsetWidth}px`,
                    height: `${element.offsetHeight}px`,
                    boxSizing: "border-box",
                    willChange: "width,margin"
                };
                Object.assign(element.style, newStyles);
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        const newStyles_0 = {
                            width: "0px",
                            margin: "0px",
                            transitionTimingFunction: "cubic-bezier(0.8,0,0,0.8)",
                            transitionDuration: (0, $4dGdo.durations)[duration] + "ms",
                            transitionProperty: "width,margin"
                        };
                        Object.assign(element.style, newStyles_0);
                        setTimeout(()=>{
                            exiting.onFinish && exiting.onFinish();
                            onFinish && onFinish("exiting");
                        }, (0, $4dGdo.durations)[duration]);
                    });
                });
            }
        };
        $[0] = duration;
        $[1] = element;
        $[2] = exiting;
        $[3] = onFinish;
        $[4] = requestAnimationFrame;
        $[5] = setTimeout;
        $[6] = t2;
    } else t2 = $[6];
    (0, $7BVQi.useLayoutEffect)(t2);
    let t3;
    if ($[7] !== children || $[8] !== direction || $[9] !== setElementRef) {
        t3 = children({
            ref: setElementRef
        }, direction);
        $[7] = children;
        $[8] = direction;
        $[9] = setElementRef;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const exiting = (0, $kUXcd.useExitingPersistence)();
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    const setTimeout = (0, $1U6E9.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $jlWUB.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles_0 = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $4dGdo.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles_0);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $4dGdo.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $638c8511a917505b$export$2e2bcd8739ae039 = $638c8511a917505b$var$ShrinkOut;
module.exports["default"] = $638c8511a917505b$export$2e2bcd8739ae039;

});

parcelRegister("22s7D", function(module, exports) {
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $cozmU = parcelRequire("cozmU");

const $209eee172d92c14c$export$50727c0a52da4015 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["SelectGetStylesContext"] = $209eee172d92c14c$export$50727c0a52da4015;

});

parcelRegister("k4Jbz", function(module, exports) {
const $0718c80905572ebe$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
module.exports["getStyleProps"] = $0718c80905572ebe$export$26417cabd806a658;

});

parcelRegister("ihhlg", function(module, exports) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $036f15bf293a6c04$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $036f15bf293a6c04$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $036f15bf293a6c04$export$803cd8101b6c182b = /*#__PURE__*/ $036f15bf293a6c04$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $036f15bf293a6c04$export$27b07d8a310ed8b5[0], side + "-" + $036f15bf293a6c04$export$27b07d8a310ed8b5[1]), []);
const $036f15bf293a6c04$export$96ec731ed4dcb222 = Math.min;
const $036f15bf293a6c04$export$8960430cfd85939f = Math.max;
const $036f15bf293a6c04$export$2077e0241d6afd3c = Math.round;
const $036f15bf293a6c04$export$a3fe094919f356fd = Math.floor;
const $036f15bf293a6c04$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $036f15bf293a6c04$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $036f15bf293a6c04$export$7d15b64cf5a3a4c4(start, value, end) {
    return $036f15bf293a6c04$export$8960430cfd85939f(start, $036f15bf293a6c04$export$96ec731ed4dcb222(value, end));
}
function $036f15bf293a6c04$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $036f15bf293a6c04$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $036f15bf293a6c04$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $036f15bf293a6c04$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $036f15bf293a6c04$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $036f15bf293a6c04$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $036f15bf293a6c04$export$2b57e0052a6d6d4c(placement) {
    return $036f15bf293a6c04$export$8a000a963141ac32($036f15bf293a6c04$export$f28e8f882010718a(placement));
}
function $036f15bf293a6c04$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $036f15bf293a6c04$export$f0989780f32bfcda(placement);
    const alignmentAxis = $036f15bf293a6c04$export$2b57e0052a6d6d4c(placement);
    const length = $036f15bf293a6c04$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $036f15bf293a6c04$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $036f15bf293a6c04$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $036f15bf293a6c04$export$496432a3699e50b1(placement) {
    const oppositePlacement = $036f15bf293a6c04$export$9c5e28bad23365fa(placement);
    return [
        $036f15bf293a6c04$export$2b182c584985588b(placement),
        oppositePlacement,
        $036f15bf293a6c04$export$2b182c584985588b(oppositePlacement)
    ];
}
function $036f15bf293a6c04$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $036f15bf293a6c04$var$lrPlacement = [
    'left',
    'right'
];
const $036f15bf293a6c04$var$rlPlacement = [
    'right',
    'left'
];
const $036f15bf293a6c04$var$tbPlacement = [
    'top',
    'bottom'
];
const $036f15bf293a6c04$var$btPlacement = [
    'bottom',
    'top'
];
function $036f15bf293a6c04$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $036f15bf293a6c04$var$rlPlacement : $036f15bf293a6c04$var$lrPlacement;
            return isStart ? $036f15bf293a6c04$var$lrPlacement : $036f15bf293a6c04$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $036f15bf293a6c04$var$tbPlacement : $036f15bf293a6c04$var$btPlacement;
        default:
            return [];
    }
}
function $036f15bf293a6c04$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $036f15bf293a6c04$export$f0989780f32bfcda(placement);
    let list = $036f15bf293a6c04$var$getSideList($036f15bf293a6c04$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($036f15bf293a6c04$export$2b182c584985588b));
    }
    return list;
}
function $036f15bf293a6c04$export$9c5e28bad23365fa(placement) {
    const side = $036f15bf293a6c04$export$3c915306cb7fc97a(placement);
    return $036f15bf293a6c04$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $036f15bf293a6c04$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $036f15bf293a6c04$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $036f15bf293a6c04$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $036f15bf293a6c04$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}
module.exports["sides"] = $036f15bf293a6c04$export$832b6fa47fa053d2;
module.exports["placements"] = $036f15bf293a6c04$export$803cd8101b6c182b;
module.exports["min"] = $036f15bf293a6c04$export$96ec731ed4dcb222;
module.exports["max"] = $036f15bf293a6c04$export$8960430cfd85939f;
module.exports["round"] = $036f15bf293a6c04$export$2077e0241d6afd3c;
module.exports["floor"] = $036f15bf293a6c04$export$a3fe094919f356fd;
module.exports["createCoords"] = $036f15bf293a6c04$export$a397704b5e280835;
module.exports["clamp"] = $036f15bf293a6c04$export$7d15b64cf5a3a4c4;
module.exports["evaluate"] = $036f15bf293a6c04$export$fef61f332f2c0afc;
module.exports["getSide"] = $036f15bf293a6c04$export$3c915306cb7fc97a;
module.exports["getAlignment"] = $036f15bf293a6c04$export$f0989780f32bfcda;
module.exports["getOppositeAxis"] = $036f15bf293a6c04$export$8a000a963141ac32;
module.exports["getAxisLength"] = $036f15bf293a6c04$export$320bd9d53520c68a;
module.exports["getSideAxis"] = $036f15bf293a6c04$export$f28e8f882010718a;
module.exports["getAlignmentAxis"] = $036f15bf293a6c04$export$2b57e0052a6d6d4c;
module.exports["getAlignmentSides"] = $036f15bf293a6c04$export$be42861551f17911;
module.exports["getOppositePlacement"] = $036f15bf293a6c04$export$9c5e28bad23365fa;
module.exports["getExpandedPlacements"] = $036f15bf293a6c04$export$496432a3699e50b1;
module.exports["getOppositeAlignmentPlacement"] = $036f15bf293a6c04$export$2b182c584985588b;
module.exports["getOppositeAxisPlacements"] = $036f15bf293a6c04$export$a9b6fb18fd92c3ec;
module.exports["getPaddingObject"] = $036f15bf293a6c04$export$598c291c29bc2e71;
module.exports["rectToClientRect"] = $036f15bf293a6c04$export$ee05aea0aeecbad4;

});

parcelRegister("3tq6j", function(module, exports) {
function $2878539f0586caca$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $2878539f0586caca$export$651544f548703224(node) {
    if ($2878539f0586caca$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $2878539f0586caca$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $2878539f0586caca$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($2878539f0586caca$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $2878539f0586caca$export$8ee0fc9ee280b4ee(value) {
    if (!$2878539f0586caca$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $2878539f0586caca$export$38b2d434cce3ea22(value).Node;
}
function $2878539f0586caca$export$45a5e7f76e0caa8d(value) {
    if (!$2878539f0586caca$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $2878539f0586caca$export$38b2d434cce3ea22(value).Element;
}
function $2878539f0586caca$export$1b3bfaa9684536aa(value) {
    if (!$2878539f0586caca$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $2878539f0586caca$export$38b2d434cce3ea22(value).HTMLElement;
}
function $2878539f0586caca$export$af51f0f06c0f328a(value) {
    if (!$2878539f0586caca$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $2878539f0586caca$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $2878539f0586caca$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $2878539f0586caca$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $2878539f0586caca$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($2878539f0586caca$export$651544f548703224(element));
}
function $2878539f0586caca$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $2878539f0586caca$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $2878539f0586caca$var$containRe = /paint|layout|strict|content/;
const $2878539f0586caca$var$isNotNone = (value)=>!!value && value !== 'none';
let $2878539f0586caca$var$isWebKitValue;
function $2878539f0586caca$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $2878539f0586caca$export$45a5e7f76e0caa8d(elementOrCss) ? $2878539f0586caca$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $2878539f0586caca$var$isNotNone(css.transform) || $2878539f0586caca$var$isNotNone(css.translate) || $2878539f0586caca$var$isNotNone(css.scale) || $2878539f0586caca$var$isNotNone(css.rotate) || $2878539f0586caca$var$isNotNone(css.perspective) || !$2878539f0586caca$export$78551043582a6a98() && ($2878539f0586caca$var$isNotNone(css.backdropFilter) || $2878539f0586caca$var$isNotNone(css.filter)) || $2878539f0586caca$var$willChangeRe.test(css.willChange || '') || $2878539f0586caca$var$containRe.test(css.contain || '');
}
function $2878539f0586caca$export$940d8225183e1404(element) {
    let currentNode = $2878539f0586caca$export$4e12058fc4d51d56(element);
    while($2878539f0586caca$export$1b3bfaa9684536aa(currentNode) && !$2878539f0586caca$export$d1162fb0b6d4cd51(currentNode)){
        if ($2878539f0586caca$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($2878539f0586caca$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $2878539f0586caca$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $2878539f0586caca$export$78551043582a6a98() {
    if ($2878539f0586caca$var$isWebKitValue == null) $2878539f0586caca$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $2878539f0586caca$var$isWebKitValue;
}
function $2878539f0586caca$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($2878539f0586caca$export$651544f548703224(node));
}
function $2878539f0586caca$export$3735103072e4a80(element) {
    return $2878539f0586caca$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $2878539f0586caca$export$dc8fc79fa2800137(element) {
    if ($2878539f0586caca$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $2878539f0586caca$export$4e12058fc4d51d56(node) {
    if ($2878539f0586caca$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $2878539f0586caca$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $2878539f0586caca$export$e495491855dc5418(node);
    return $2878539f0586caca$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $2878539f0586caca$export$7cd01a57c8ca906c(node) {
    const parentNode = $2878539f0586caca$export$4e12058fc4d51d56(node);
    if ($2878539f0586caca$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($2878539f0586caca$export$1b3bfaa9684536aa(parentNode) && $2878539f0586caca$export$989e911fa9af580a(parentNode)) return parentNode;
    return $2878539f0586caca$export$7cd01a57c8ca906c(parentNode);
}
function $2878539f0586caca$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $2878539f0586caca$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $2878539f0586caca$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $2878539f0586caca$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $2878539f0586caca$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $2878539f0586caca$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $2878539f0586caca$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $2878539f0586caca$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
module.exports["getNodeName"] = $2878539f0586caca$export$651544f548703224;
module.exports["getWindow"] = $2878539f0586caca$export$38b2d434cce3ea22;
module.exports["getDocumentElement"] = $2878539f0586caca$export$e495491855dc5418;
module.exports["isElement"] = $2878539f0586caca$export$45a5e7f76e0caa8d;
module.exports["isHTMLElement"] = $2878539f0586caca$export$1b3bfaa9684536aa;
module.exports["isOverflowElement"] = $2878539f0586caca$export$989e911fa9af580a;
module.exports["getComputedStyle"] = $2878539f0586caca$export$3735103072e4a80;
module.exports["isTableElement"] = $2878539f0586caca$export$71535ffaa902797f;
module.exports["isTopLayer"] = $2878539f0586caca$export$89e651af02346cd4;
module.exports["isContainingBlock"] = $2878539f0586caca$export$d6c4e8150c35fed1;
module.exports["isWebKit"] = $2878539f0586caca$export$78551043582a6a98;
module.exports["getContainingBlock"] = $2878539f0586caca$export$940d8225183e1404;
module.exports["getParentNode"] = $2878539f0586caca$export$4e12058fc4d51d56;
module.exports["isLastTraversableNode"] = $2878539f0586caca$export$d1162fb0b6d4cd51;
module.exports["getNodeScroll"] = $2878539f0586caca$export$dc8fc79fa2800137;
module.exports["getOverflowAncestors"] = $2878539f0586caca$export$3b57c1601291186b;
module.exports["getFrameElement"] = $2878539f0586caca$export$7bf1f8740e3e34af;

});

parcelRegister("310h3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8085fafb706d58da$export$e001f626511a0ead = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["PortalPlacementContext"] = $8085fafb706d58da$export$e001f626511a0ead;

});

parcelRegister("70HV3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $44c475e003825a89$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["MenuPortalCloseContext"] = $44c475e003825a89$export$a0d5b29fa9affc38;

});


$parcel$global.rlb("lkxmG")
//# sourceMappingURL=manual-triggers-modal.06c1630a.js.map
